import { render, staticRenderFns } from "./UploadStatusBanner.vue?vue&type=template&id=bf67a5d2"
import script from "./UploadStatusBanner.vue?vue&type=script&lang=js"
export * from "./UploadStatusBanner.vue?vue&type=script&lang=js"
import style0 from "./UploadStatusBanner.vue?vue&type=style&index=0&id=bf67a5d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports